<template>
  <el-table-column
    prop="diff_blame_deadline_date"
    sortable="custom"
    label="Eltérések miatti felelősség megállapítása"
    show-overflow-tooltip
    min-width="320"
  >
    <template slot-scope="scope">
      {{ scope.row.diff_blame_deadline_date | dateTime }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'diff_blame_deadline_date',
  };
</script>
